import React,{useEffect, useState} from 'react'

const DarkMode = () => {
    const [theme, setTheme] = useState(
        localStorage.getItem('theme') || 'light'
        );
    const toggleTheme = () => {
        if (theme === 'light') {
            setTheme('dark-theme');
        } else {
            setTheme('light');
        }
    };
        useEffect(() => {
        localStorage.setItem('theme', theme);
        document.body.className = theme;
        }, [theme]);

    return (
        <>
            <i className={theme === 'light' ? "ri-moon-line change-theme" : "ri-sun-line change-theme"} onClick={toggleTheme}></i>
        </>
    )
}

export default DarkMode